import { ReactElement, useEffect } from 'react';
import useUrlParams from '../hooks/utility/useUrlParams';
import { UTMInterface } from '../services/exports/Interfaces';
import { ENVIRONMENTS } from '../services/exports/Constants';
import ReactPixel from 'react-facebook-pixel';
import useInitialData from '../hooks/global/useInitialData';
import { setUtm } from '../services/exports/Cookies';
import collect from 'collect.js';
import { getStorefrontOrigin } from '../modules/storefront/exports/Cookies';
import useMobileApp from '../hooks/mobile-app/useMobileApp';

interface Props {
  children: ReactElement;
}

export default function TrackingProvider({ children }: Props) {
  const params = useUrlParams();
  const { isMobileApp } = useMobileApp();
  const { data } = useInitialData();
  const { franchise } = data;

  const referrer = document.referrer ? new URL(document.referrer).origin : null;
  const utmSource = isMobileApp ? 'mobile_app' : params?.utm_source;

  const utmQueryParams: UTMInterface = {
    utm_source: utmSource,
    utm_medium: params?.utm_medium,
    utm_campaign: params?.utm_campaign,
    utm_tracking_link_id: params?.utm_tracking_link_id,
    gclid: params?.gclid,
    fbclid: params?.fbclid,
  };

  const blacklist = ['paypal'];

  const saveUtm = (): void => {
    if (referrer && blacklist.some((item) => referrer.includes(item))) return;

    if (
      collect(utmQueryParams)
        .values()
        .filter((item) => !!item)
        .isNotEmpty()
    ) {
      return setUtm(utmQueryParams);
    }

    if (getStorefrontOrigin()) return;

    if (referrer) {
      setUtm({
        ...utmQueryParams,
        utm_source: referrer,
      });
    }
  };

  useEffect(() => {
    saveUtm();
  }, []);

  useEffect(() => {
    if (franchise?.facebook_pixel_id) {
      ReactPixel.init(franchise.facebook_pixel_id, null, {
        autoConfig: true,
        debug: import.meta.env.VITE_MODE !== ENVIRONMENTS.PROD,
      });
      ReactPixel.pageView();
    }
  }, [franchise?.facebook_pixel_id]);

  return children;
}
